<div class="dialog-header">
  <h3 translate>car-workshop-pendencies-dialog.title</h3>
  <button
    class="close-button"
    mat-icon-button
    tabindex="-1"
    cdkFocusInitial
    (click)="closeDialog()"
  >
    <i class="bosch-ic bosch-ic-clickable bosch-ic-close"></i>
  </button>
</div>
<mat-dialog-content>
  <mat-button-toggle-group class="tabs-group" [formControl]="option">
    <mat-button-toggle
      value="invoicesPendencies"
      [matBadge]="totalInvoicesPendencies"
      [disabled]="!totalInvoicesPendencies"
    >
      <mat-icon fontIcon="bosch-ic-checklist"></mat-icon>
      {{ "car-workshop-pendencies-dialog.invoices-pendencies" | translate }}
    </mat-button-toggle>

    <mat-button-toggle
      value="budgetPendencies"
      [matBadge]="totalBudgetPendencies"
      [disabled]="!totalBudgetPendencies"
    >
      <mat-icon fontIcon="bosch-ic-checklist"></mat-icon>
      {{ "car-workshop-pendencies-dialog.budget-pendencies" | translate }}
    </mat-button-toggle>

    <mat-button-toggle
      value="preventiveProposals"
      [matBadge]="totalPreventiveProposals"
      [disabled]="!totalPreventiveProposals"
    >
      <mat-icon fontIcon="bosch-ic-checklist"></mat-icon>
      {{ "car-workshop-pendencies-dialog.preventive-proposals" | translate }}
    </mat-button-toggle>
  </mat-button-toggle-group>

  <div class="dialog-content">
    <div class="pendencies" *ngIf="option.value === 'invoicesPendencies'">
      <div
        *ngFor="let pendency of invoicesPendencies"
        class="pendencies__pendency"
      >
        {{ pendency }}
      </div>
    </div>

    <div class="pendencies" *ngIf="option.value === 'budgetPendencies'">
      <div
        *ngFor="let pendency of budgetPendencies"
        class="pendencies__pendency"
      >
        {{ pendency }}
      </div>
    </div>

    <div class="pendencies" *ngIf="option.value === 'preventiveProposals'">
      <div
        *ngFor="let pendency of preventiveProposals"
        class="pendencies__pendency"
      >
        {{ pendency }}
      </div>
    </div>
  </div>
</mat-dialog-content>

<div class="dialog-actions">
  <button
    class="sample-button sample-button--primary"
    (click)="goToServicesRequestTable()"
  >
    {{ "mandatory-data-update-car-workshop-dialog.proceed-button" | translate }}
  </button>
</div>
